import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps.site != this.props.site) {
            return true;
        }

        if (nextProps.user != this.props.user) {
            return true;
        }

        return false;
    }

    render({ user, site }) {
        if (user.logged_in) {
            let age = this.get_age();
            let url = `https://ps.eyeota.net/pixel?pid=ioi0rgu&t=ajs&sid=${site}&age=${age}&gender=${user.sex}`;

            return (
                <eyeota>
                    <script type='text/javascript' async defer src={url} />
                </eyeota>
            );
        }

        return (<eyeota />);
    }

    get_age = () => {
        if (! this.props.user.birth_date) {
            return null;
        }

        let bd = new Date(this.props.user.birth_date);
        let currentTime = new Date();

        return Math.floor((currentTime - bd)/(365 * 86400000));
    }
}

const mapStateToProps = (state) => ({
    site: state.property_id == 17 ? 'mtarot' : 'tarot',
    user: state.user,
});

export default connect(mapStateToProps)(Component);
